export default __webpack_public_path__ + "static/media/prj_4.50a84975.png";